import React from 'react';

interface CalendarStats {
	totalCalls: number;
	meetings: number;
	pending: number;
}

interface CalendarStatsCardProps {
	stats: CalendarStats;
	month: string;
}

export const CalendarStatsCard: React.FC<CalendarStatsCardProps> = ({ stats, month }) => {
	return (
		<div className="bg-white rounded-xl shadow p-4">
			<div className="font-semibold text-gray-700 mb-3">{month}</div>
			<div className="flex gap-4">
				<div className="flex-1 text-center">
					<div className="text-2xl font-bold text-gray-900">{stats.totalCalls}</div>
					<div className="text-gray-500 text-sm">Total Calls</div>
				</div>
				<div className="flex-1 text-center">
					<div className="text-2xl font-bold text-gray-900">{stats.meetings}</div>
					<div className="text-gray-500 text-sm">Meetings</div>
				</div>
				<div className="flex-1 text-center">
					<div className="text-2xl font-bold text-gray-900">{stats.pending}</div>
					<div className="text-gray-500 text-sm">Pending</div>
				</div>
			</div>
		</div>
	);
};
